export default __webpack_public_path__ + "fonts/ed40ebc6e651b471e490973dc3dbff3a.svg";